import React from "react";
import NotifactionMobile from "../../../common/mobile/notifactionMobile/NotifactionMobile";

export function Notification() {
  return <NotifactionMobile />;
}

export default Notification;
